import { create } from "zustand";

const useDateStore = create(set => ({
  date: new Date(),
  setDate: date => set({ date })
}));

export default useDateStore;
